/* ═══════════════════════════════════════════════════════════
   iGrow Carpet — Learning Hub monetisation blocks  (v3.1)
   Dark email capture + gradient product grid cards.
   v3.1: product grid cards show "From £24.99".

   Article usage (three placeholders):
     <div class="igc-bundle-strip" data-ref="aeration"></div>
     <div class="igc-email-capture" data-ref="aeration"></div>
     <div class="igc-product-grid" data-ref="aeration"></div>

   TO UPDATE PRICES, VARIANTS OR IMAGES: edit CONFIG below.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CONFIG = {
    shop: 'https://www.igrowcarpet.co.uk',
    klaviyoCompany: 'RJJ2J2',
    klaviyoList: 'USxfQX',
    seaweedVariant: '52617518776666',
    seasons: {
      spring: { name: 'Spring', small: '50760100381018', large: '50760100413786',
                img: 'https://www.igrowcarpet.co.uk/cdn/shop/files/iGrowCarpetSpring2.5kgand8kg.jpg?v=1772107191',
                productName: 'Spring Starter Plus', productUrl: '/products/spring-fertiliser',
                gradient: 'linear-gradient(135deg, #6dc950 0%, #3d8a2e 100%)' },
      summer: { name: 'Summer', small: '51485773726042', large: '51485773758810',
                img: 'https://cdn.shopify.com/s/files/1/0938/1412/8986/files/summer_advance_15-0-10.jpg?v=1780396596',
                productName: 'Summer Advance', productUrl: '/products/summer-fertiliser',
                gradient: 'linear-gradient(135deg, #88b73a 0%, #5e8521 100%)' },
      autumn: { name: 'Autumn', small: '51485832282458', large: '51485832315226',
                img: 'https://www.igrowcarpet.co.uk/cdn/shop/files/iGrowCarpetAutumnlawnbuilder2.5kgand8kgbags.jpg?v=1756458673',
                productName: 'Autumn Lawn Builder', productUrl: '/products/autumn-fertiliser',
                gradient: 'linear-gradient(135deg, #6b8a2e 0%, #4a5d18 100%)' }
    },
    winterGradient: 'linear-gradient(135deg, #2d6e3d 0%, #1a4a35 100%)',
    powerPackDiscount: 'MEASURE-POWERPACK10',
    powerPackPrices: { small: { price: '£44.98', was: '£49.98', save: '£5.00' },
                       large: { price: '£62.98', was: '£69.98', save: '£7.00' } },
    liquidCombo:   { cart: '54032142270810:1,52617518776666:1', discount: 'MEASURE-LIQUIDCOMBO',
                     price: '£44.98', was: '£49.98', save: '£5.00',
                     gradient: 'linear-gradient(135deg, #4a8a5e 0%, #2d5a3a 100%)' },
    secretFormula: { cart: '54032045113690:1,52617518776666:1', discount: 'MEASURE-SECRETFORMULA',
                     price: '£42.99', was: '£47.49', save: '£4.50',
                     gradient: 'linear-gradient(135deg, #5a7a3a 0%, #3a5520 100%)' },
    liquidPlusVariant: '54032142270810',
    products: {
      seasonalPrice: 'From £24.99',
      seaweedPrice: 'From £24.99',
      liquidPlusPrice: 'From £24.99',
      seaweedGradient: 'linear-gradient(135deg, #2d8a5e 0%, #1a5c3d 100%)',
      liquidPlusGradient: 'linear-gradient(135deg, #4a8a5e 0%, #2d5a3a 100%)'
    },
    images: {
      seaweed:    'https://www.igrowcarpet.co.uk/cdn/shop/files/igrow-carpet-product_seaweed-1.jpg?v=1772199993',
      liquidPlus: 'https://www.igrowcarpet.co.uk/cdn/shop/files/iGrowCarpet1lliquidplus.jpg',
      liquidPlusFallback: 'https://www.igrowcarpet.co.uk/cdn/shop/files/GreenShotLiquidPlus.jpg?v=1779732791',
      iron:       'https://www.igrowcarpet.co.uk/cdn/shop/files/2kg_Iron_on_its_own.jpg?v=1782902865'
    }
  };

  function seasonKey() {
    var m = new Date().getMonth();
    if (m >= 2 && m <= 4) return 'spring';
    if (m >= 5 && m <= 7) return 'summer';
    if (m >= 8 && m <= 10) return 'autumn';
    return 'winter';
  }
  function season() {
    var k = seasonKey();
    return CONFIG.seasons[k === 'winter' ? 'autumn' : k];
  }
  function seasonName() {
    var k = seasonKey();
    return k.charAt(0).toUpperCase() + k.slice(1);
  }
  function seasonGradient() {
    var k = seasonKey();
    return k === 'winter' ? CONFIG.winterGradient : CONFIG.seasons[k].gradient;
  }
  function utm(ref) {
    return 'ref=' + ref + '&utm_source=learning-hub&utm_medium=blog&utm_campaign=' + ref;
  }
  function prettyRef(ref) {
    return ref.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }
  function ensureFontAwesome() {
    if (!document.querySelector('link[href*="font-awesome"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css';
      document.head.appendChild(l);
    }
  }

  /* ─── Shared stylesheet (injected once) ─── */
  function ensureStyles() {
    if (document.getElementById('igc-blocks-css')) return;
    var s = document.createElement('style');
    s.id = 'igc-blocks-css';
    s.textContent =
      '.igc-strip,.igc-grid{background:#0d1f0d;border-radius:12px;padding:26px 22px;margin:2rem 0;}' +
      '.igc-grid{margin:3rem 0;}' +
      '.igc-strip h3,.igc-grid h3{color:#8aba6a;font-size:22px;font-weight:700;margin:0 0 8px;}' +
      '.igc-grid h3{font-size:24px;text-align:center;}' +
      '.igc-strip>p,.igc-grid>p{color:#cfe0c2;margin:0 0 20px;line-height:1.6;}' +
      '.igc-grid>p{text-align:center;}' +
      '.igc-cards{display:flex;flex-wrap:wrap;gap:14px;}' +

      '.igc-bcard{flex:1;min-width:240px;border-radius:12px;padding:20px;padding-top:52px;position:relative;overflow:hidden;color:#fff;text-align:center;display:flex;flex-direction:column;}' +
      '.igc-bcard.igc-nobadge{padding-top:20px;}' +
      '.igc-bcard::before{content:"";position:absolute;top:-40%;right:-10%;width:220px;height:220px;background:radial-gradient(circle,rgba(255,255,255,0.15) 0%,transparent 70%);pointer-events:none;}' +
      '.igc-badge{position:absolute;top:14px;left:50%;transform:translateX(-50%);background:#ffc107;color:#1a1a1a;padding:5px 14px;border-radius:20px;font-size:11px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,0.15);display:inline-flex;align-items:center;gap:5px;z-index:2;}' +
      '.igc-imgstack{position:relative;width:104px;height:84px;margin:0 auto 12px;}' +
      '.igc-imgstack img{position:absolute;width:70px;height:70px;border-radius:8px;object-fit:cover;border:2px solid #fff;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,0.2);}' +
      '.igc-imgstack img:nth-child(1){left:0;top:7px;transform:rotate(-4deg);z-index:1;}' +
      '.igc-imgstack img:nth-child(2){right:0;top:7px;transform:rotate(4deg);z-index:2;}' +
      '.igc-imgsolo{display:block;width:84px;height:84px;border-radius:8px;object-fit:cover;border:2px solid #fff;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,0.2);margin:0 auto 12px;transform:rotate(-3deg);}' +
      '.igc-eyebrow{font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:1.5px;opacity:.9;margin-bottom:4px;display:flex;align-items:center;justify-content:center;gap:6px;}' +
      '.igc-btitle{font-size:18px;font-weight:700;margin:0 0 4px;color:#fff;letter-spacing:-.2px;}' +
      '.igc-bcontents{font-size:13px;opacity:.9;margin:0 0 10px;line-height:1.5;flex:1;}' +
      '.igc-pricing{display:flex;align-items:baseline;justify-content:center;gap:10px;margin-bottom:6px;flex-wrap:wrap;}' +
      '.igc-price{font-size:22px;font-weight:700;color:#fff;}' +
      '.igc-was{font-size:14px;text-decoration:line-through;opacity:.7;}' +
      '.igc-savepill{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:600;color:#ffc107;background:rgba(0,0,0,0.15);padding:3px 10px;border-radius:10px;margin:0 auto 12px;}' +
      '.igc-sizes{font-size:12px;opacity:.85;margin:0 0 10px;}' +
      '.igc-btn-white{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 22px;background:#fff;color:#2d8a1e;border-radius:8px;font-weight:700;font-size:14px;text-decoration:none;box-shadow:0 2px 8px rgba(0,0,0,0.15);transition:all .25s;}' +
      '.igc-btn-white:hover{background:#f0f9ee;transform:translateY(-1px);color:#2d8a1e;}' +
      '.igc-btnrow{display:flex;gap:10px;}' +
      '.igc-btnrow .igc-btn-white{flex:1;}' +
      '.igc-btn-full{width:100%;box-sizing:border-box;}' +
      '.igc-measure-link{margin:18px 0 0;text-align:center;}' +
      '.igc-measure-link a{color:#8aba6a;font-weight:700;text-decoration:underline;}' +
      '.igc-measure-link a:hover{color:#fff;}' +

      '.igc-email{background:#0d1f0d;border-radius:12px;padding:26px 22px;margin:2rem 0;box-shadow:0 4px 16px rgba(0,0,0,0.15);}' +
      '.igc-email h3{color:#8aba6a;font-size:22px;font-weight:700;margin:0 0 10px;}' +
      '.igc-email p{margin:0 0 16px;color:#cfe0c2;line-height:1.6;}' +
      '.igc-nl-form{display:flex;flex-wrap:wrap;gap:10px;}' +
      '.igc-nl-email{flex:1;min-width:200px;min-height:48px;padding:12px 16px;border:2px solid #2d4a2d;border-radius:8px;font-size:16px;background:#fff;}' +
      '.igc-nl-btn{min-height:48px;background:#63D84F;color:#fff;font-weight:700;font-size:15px;border:none;border-radius:8px;padding:12px 24px;cursor:pointer;transition:all .25s;}' +
      '.igc-nl-btn:hover{background:#52c33f;}' +
      '.igc-nl-done{display:none;align-items:center;gap:8px;color:#8fd97a;font-weight:600;min-height:48px;}' +

      '@media (max-width:640px){' +
        '.igc-bcard{min-width:100%;}' +
        '.igc-strip,.igc-grid,.igc-email{padding:22px 16px;}' +
        '.igc-nl-form{flex-direction:column;}' +
        '.igc-nl-email,.igc-nl-btn{width:100%;box-sizing:border-box;}' +
      '}';
    document.head.appendChild(s);
  }

  /* ─── Block 1: Bundle strip ─── */
  function renderBundleStrip(el) {
    var ref = el.getAttribute('data-ref') || 'learning-hub';
    var s = season(), sName = seasonName(), q = utm(ref);
    var pp = CONFIG.powerPackPrices;
    var ppCart = function (id) {
      return CONFIG.shop + '/cart/' + id + ':1,' + CONFIG.seaweedVariant + ':1?discount=' + CONFIG.powerPackDiscount + '&' + q;
    };

    el.innerHTML =
      '<aside class="igc-strip">' +
        '<h3>Fancy supporting all this free stuff?</h3>' +
        '<p>Supporting the shop helps us create more free content. These are the bundles I\u2019d point you at, and each one saves you a few quid.</p>' +
        '<div class="igc-cards">' +

          '<div class="igc-bcard" style="background:' + seasonGradient() + ';">' +
            '<span class="igc-badge"><i class="fa-solid fa-tag"></i> Save 10%</span>' +
            '<div class="igc-imgstack">' +
              '<img src="' + s.img + '" alt="' + s.productName + '">' +
              '<img src="' + CONFIG.images.seaweed + '" alt="Seaweed Lawn Booster">' +
            '</div>' +
            '<div class="igc-eyebrow"><i class="fa-solid fa-box-open"></i> Best-fit bundle</div>' +
            '<div class="igc-btitle">' + sName + ' Power Pack</div>' +
            '<p class="igc-bcontents">This season\u2019s feed + Seaweed Lawn Booster. The two that do the most for your lawn.</p>' +
            '<div class="igc-pricing"><span class="igc-price">' + pp.small.price + '</span><span class="igc-was">' + pp.small.was + '</span></div>' +
            '<span class="igc-savepill"><i class="fa-solid fa-piggy-bank"></i> Save ' + pp.small.save + ' (2.5kg) \u00b7 ' + pp.large.save + ' (8kg)</span>' +
            '<div class="igc-sizes">2.5kg for small lawns \u00b7 8kg for big lawns (' + pp.large.price + ')</div>' +
            '<div class="igc-btnrow">' +
              '<a href="' + ppCart(s.small) + '" class="igc-btn-white" aria-label="Add the 2.5kg ' + sName + ' Power Pack to your cart"><i class="fa-solid fa-cart-plus"></i> 2.5kg</a>' +
              '<a href="' + ppCart(s.large) + '" class="igc-btn-white" aria-label="Add the 8kg ' + sName + ' Power Pack to your cart"><i class="fa-solid fa-cart-plus"></i> 8kg</a>' +
            '</div>' +
          '</div>' +

          '<div class="igc-bcard" style="background:' + CONFIG.liquidCombo.gradient + ';">' +
            '<span class="igc-badge"><i class="fa-solid fa-tag"></i> Save ' + CONFIG.liquidCombo.save + '</span>' +
            '<div class="igc-imgstack">' +
              '<img src="' + CONFIG.images.liquidPlus + '" onerror="this.src=\'' + CONFIG.images.liquidPlusFallback + '\'" alt="Green Shot Liquid Plus">' +
              '<img src="' + CONFIG.images.seaweed + '" alt="Seaweed Lawn Booster">' +
            '</div>' +
            '<div class="igc-eyebrow"><i class="fa-solid fa-droplet"></i> Liquid duo \u2014 year round</div>' +
            '<div class="igc-btitle">The Greenkeeper\u2019s Liquid Combo</div>' +
            '<p class="igc-bcontents">Green Shot Liquid Plus + Seaweed Lawn Booster. Your two liquids, together.</p>' +
            '<div class="igc-pricing"><span class="igc-price">' + CONFIG.liquidCombo.price + '</span><span class="igc-was">' + CONFIG.liquidCombo.was + '</span></div>' +
            '<span class="igc-savepill"><i class="fa-solid fa-piggy-bank"></i> Save ' + CONFIG.liquidCombo.save + '</span>' +
            '<a href="' + CONFIG.shop + '/cart/' + CONFIG.liquidCombo.cart + '?discount=' + CONFIG.liquidCombo.discount + '&' + q + '" class="igc-btn-white igc-btn-full" aria-label="Add the Greenkeeper\u2019s Liquid Combo to your cart"><i class="fa-solid fa-cart-plus"></i> Add Bundle</a>' +
          '</div>' +

          '<div class="igc-bcard" style="background:' + CONFIG.secretFormula.gradient + ';">' +
            '<span class="igc-badge"><i class="fa-solid fa-tag"></i> Save ' + CONFIG.secretFormula.save + '</span>' +
            '<div class="igc-imgstack">' +
              '<img src="' + CONFIG.images.iron + '" alt="Green Shot Iron">' +
              '<img src="' + CONFIG.images.seaweed + '" alt="Seaweed Lawn Booster">' +
            '</div>' +
            '<div class="igc-eyebrow"><i class="fa-solid fa-bolt"></i> Iron + seaweed \u2014 year round</div>' +
            '<div class="igc-btitle">The Greenkeeper\u2019s Secret Formula</div>' +
            '<p class="igc-bcontents">Green Shot Iron + Seaweed Lawn Booster. Deep colour and a soil boost in one.</p>' +
            '<div class="igc-pricing"><span class="igc-price">' + CONFIG.secretFormula.price + '</span><span class="igc-was">' + CONFIG.secretFormula.was + '</span></div>' +
            '<span class="igc-savepill"><i class="fa-solid fa-piggy-bank"></i> Save ' + CONFIG.secretFormula.save + '</span>' +
            '<a href="' + CONFIG.shop + '/cart/' + CONFIG.secretFormula.cart + '?discount=' + CONFIG.secretFormula.discount + '&' + q + '" class="igc-btn-white igc-btn-full" aria-label="Add the Greenkeeper\u2019s Secret Formula to your cart"><i class="fa-solid fa-cart-plus"></i> Add Bundle</a>' +
          '</div>' +

        '</div>' +
      '</aside>';
  }

  /* ─── Block 2: Email capture (dark) ─── */
  function renderEmailCapture(el) {
    var ref = el.getAttribute('data-ref') || 'learning-hub';
    var source = el.getAttribute('data-source') || ('Learning Hub - ' + prettyRef(ref));

    el.innerHTML =
      '<aside class="igc-email">' +
        '<h3>Enjoying this? Get the good stuff by email</h3>' +
        '<p>At the start of each month I send out what your lawn needs that month. What to do, what to skip, and the mistakes to avoid. Free, and you can leave any time.</p>' +
        '<div class="igc-nl-form">' +
          '<input type="email" class="igc-nl-email" placeholder="your@email.com" autocomplete="email" inputmode="email">' +
          '<button type="button" class="igc-nl-btn">Join the newsletter</button>' +
        '</div>' +
        '<div class="igc-nl-done"><i class="fa-solid fa-circle-check"></i> You\u2019re in. First one lands at the start of the month.</div>' +
      '</aside>';

    var input = el.querySelector('.igc-nl-email');
    var btnEl = el.querySelector('.igc-nl-btn');

    function join() {
      var e = (input.value || '').trim();
      if (!e || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)) { alert('Pop a valid email address in first.'); input.focus(); return; }
      btnEl.disabled = true; btnEl.textContent = 'Joining...';
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CONFIG.klaviyoCompany, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          profile: { data: { type: 'profile', attributes: { email: e, properties: { 'SignupArticle': ref } } } },
          custom_source: source
        }, relationships: { list: { data: { type: 'list', id: CONFIG.klaviyoList } } } } })
      }).then(function (r) {
        if (r.ok || r.status === 202) {
          el.querySelector('.igc-nl-form').style.display = 'none';
          el.querySelector('.igc-nl-done').style.display = 'flex';
        } else { throw new Error('f'); }
      }).catch(function () {
        btnEl.disabled = false; btnEl.textContent = 'Join the newsletter';
        alert('Something went wrong. Please try again.');
      });
    }
    btnEl.addEventListener('click', join);
    input.addEventListener('keypress', function (ev) { if (ev.key === 'Enter') join(); });
  }

  /* ─── Block 3: Product grid (gradient cards) ─── */
  function renderProductGrid(el) {
    var ref = el.getAttribute('data-ref') || 'learning-hub';
    var s = season(), q = utm(ref);

    el.innerHTML =
      '<aside class="igc-grid">' +
        '<h3>Get the products for the job</h3>' +
        '<p>The two most people reach for, and a free tool to work out how much you need.</p>' +
        '<div class="igc-cards">' +

          '<div class="igc-bcard igc-nobadge" style="background:' + seasonGradient() + ';">' +
            '<img class="igc-imgsolo" src="' + s.img + '" alt="' + s.productName + '">' +
            '<div class="igc-eyebrow"><i class="fa-solid fa-seedling"></i> This season\u2019s feed</div>' +
            '<div class="igc-btitle">' + s.productName + '</div>' +
            '<p class="igc-bcontents">This season\u2019s granular feed. Slow-release, feeds for weeks.</p>' +
            '<div class="igc-pricing"><span class="igc-price">' + CONFIG.products.seasonalPrice + '</span></div>' +
            '<a href="' + CONFIG.shop + s.productUrl + '?' + q + '" class="igc-btn-white igc-btn-full">Shop <i class="fa-solid fa-arrow-right"></i></a>' +
          '</div>' +

          '<div class="igc-bcard" style="background:' + CONFIG.products.seaweedGradient + ';">' +
            '<span class="igc-badge"><i class="fa-solid fa-star"></i> Most popular</span>' +
            '<img class="igc-imgsolo" src="' + CONFIG.images.seaweed + '" alt="Seaweed Lawn Booster">' +
            '<div class="igc-eyebrow"><i class="fa-solid fa-leaf"></i> Soil health \u2014 year round</div>' +
            '<div class="igc-btitle">Seaweed Lawn Booster</div>' +
            '<p class="igc-bcontents">Feeds the soil, not just the grass. Good to use all year, every month.</p>' +
            '<div class="igc-pricing"><span class="igc-price">' + CONFIG.products.seaweedPrice + '</span></div>' +
            '<a href="' + CONFIG.shop + '/products/seaweed-lawn-booster?' + q + '" class="igc-btn-white igc-btn-full">Shop <i class="fa-solid fa-arrow-right"></i></a>' +
          '</div>' +

          '<div class="igc-bcard igc-nobadge" style="background:' + CONFIG.products.liquidPlusGradient + ';">' +
            '<img class="igc-imgsolo" src="' + CONFIG.images.liquidPlus + '" onerror="this.src=\'' + CONFIG.images.liquidPlusFallback + '\'" alt="Green Shot Liquid Plus">' +
            '<div class="igc-eyebrow"><i class="fa-solid fa-droplet"></i> Fast colour</div>' +
            '<div class="igc-btitle">Green Shot Liquid Plus</div>' +
            '<p class="igc-bcontents">A fast liquid hit of colour. Goes on with a sprayer, works in days.</p>' +
            '<div class="igc-pricing"><span class="igc-price">' + CONFIG.products.liquidPlusPrice + '</span></div>' +
            '<a href="' + CONFIG.shop + '/cart/' + CONFIG.liquidPlusVariant + ':1?' + q + '" class="igc-btn-white igc-btn-full">Add <i class="fa-solid fa-cart-plus"></i></a>' +
          '</div>' +

        '</div>' +
        '<p class="igc-measure-link"><a href="' + CONFIG.shop + '/pages/measure?' + q + '">Not sure how much you need? Measure your lawn \u2192</a></p>' +
      '</aside>';
  }

  /* ─── Boot ─── */
  function init() {
    ensureFontAwesome();
    ensureStyles();
    document.querySelectorAll('.igc-bundle-strip').forEach(renderBundleStrip);
    document.querySelectorAll('.igc-email-capture').forEach(renderEmailCapture);
    document.querySelectorAll('.igc-product-grid').forEach(renderProductGrid);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();